import React, { memo } from 'react';
import styles from './question.module.scss';

export const Question = memo(({title, subTitle, number}) => {
  return (
    <div className={`${styles.question}`}>
      <div className={styles.icon}>Q{number}</div>
      <div className={styles.title}>
        <h3 className={`${styles.main}`}>{title}</h3>
				{
					subTitle && (
						<p className={styles.sub}>{subTitle}</p>
					)
				}
      </div>
    </div>
  );
});
